import { formatDateTimeWithTimeZone } from '../../utils/getDateFormat';

function getDetails(imageJSON, reportInfo) {
  const { main } = imageJSON || {};
  const { image_id, origin_path, date_taken_milliseconds, assessment } = main || {};

  const {
    site_id = '',
    equipment = '',
    recommendation = '',
  } = reportInfo?.image_options[image_id] || {};

  // TODO: temporary until status can be pulled directly from columbia info json
  const { status_number, status_text, reason_code_number, reason_code_text } = assessment || {};

  const details = {
    image_id,
    name: origin_path,
    date_taken: date_taken_milliseconds,
    site_id,
    equipment,
    recommendation,
    status_code: status_number,
    status_text: status_text,
    reason_code: reason_code_number,
    reason_text: reason_code_text,
  };

  return details;
}

function getMarkers(marker_info, units = 'C') {
  units = typeof units === 'string' && units.toUpperCase().startsWith('F') ? 'F' : 'C';

  const markers = marker_info?.map((marker) => ({
    label: marker?.markername,
    temperature: `${marker?.maxtemperature?.[units]} °${units}` || '--',
    delta: marker?.delta?.[units] || '--',
    reference: marker?.reference ? 'x' : '',
  }));

  return markers;
}

function getInfo(image_info, timezone = 'America/Los_Angeles', units = 'C') {
  units = typeof units === 'string' && units.toUpperCase().startsWith('F') ? 'F' : 'C';

  const tempUnits = {
    C: '°C',
    F: '°F',
  };

  let info = {};

  image_info &&
    image_info.map((row) => {
      const { type, value } = row;

      if (type === 'temperature') {
        info = {
          ...info,
          [row.name]: value[units] !== null ? `${value[units]} ${tempUnits[units]}` : '--',
        };
        return;
      }

      if (type === 'temperature_range') {
        const minTemp = value['FROM'][units];
        const maxTemp = value['TO'][units];
        info = {
          ...info,
          [row.name]:
            minTemp !== null && maxTemp !== null
              ? `${minTemp} - ${maxTemp} ${tempUnits[units]}`
              : '--',
        };
        return;
      }

      if (type === 'milliseconds') {
        info = {
          ...info,
          [row.name]: value ? formatDateTimeWithTimeZone(value, timezone) : '--',
        };
        return;
      }

      info = { ...info, [row.name]: value || '--' };
    });

  return info;
}

function getNotes(notes = []) {
  const noteEntries = notes.map((entry) => ({
    user: entry.user,
    date: formatDateTimeWithTimeZone(entry.date),
    text: entry.text,
  }));

  return noteEntries;
}

export default { getDetails, getMarkers, getInfo, getNotes };
